export const SET_ERROR = 'setError';
export const SET_ITEMS = 'setItems';
export const SET_ITEM = 'setItem';
export const SET_FILTERS = 'setFilters';
export const SET_AUTH = 'setAuth';

export const SHOW_MODAL = 'show';
export const HIDE_MODAL = 'hide';

export const REMOVE_AUTH = 'removeAuth';
export const REMOVE_ITEM = 'removeItem';
export const REMOVE_FILTER = 'removeFilter';
export const REMOVE_FILTERS = 'removeFilters';
